import { css } from '@/styled-system/css';

export const returnStyles = css.raw({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  marginBlock: '400',
  padding: '200',
});

export const outputsPairContainerStyles = css.raw({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  paddingTop: { base: '600', md: '0' },
  paddingRight: { base: '0', md: '600' },
  '&:last-of-type': {
    paddingRight: '0',
  },
});
